document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.home-slider-container').forEach(container => {
        initializeSlider(container);
    });

    const nextBtn = document.querySelector('.home-slide-next');
    if (nextBtn) {
        nextBtn.style.transform = 'scale(1)';
    }
});

function initializeSlider(container) {
    const slides = container.querySelectorAll('.home-slide');

    if (slides.length === 0) {
        console.error('No slides found!');
        return;
    }

    let currentHomeSlide = 0;
    let homeSlidesToShow = 1;
    let totalHomePages = Math.ceil(slides.length / homeSlidesToShow);

    window.addEventListener('resize', () => {
        totalHomePages = Math.ceil(slides.length / homeSlidesToShow);
        updateSlider(container, currentHomeSlide, homeSlidesToShow);
    });

    container.querySelector('.home-slide-next').addEventListener('click', () => {
        moveSlide(1);
    });

    container.querySelector('.home-slide-prev').addEventListener('click', () => {
        moveSlide(-1);
    });

    function moveSlide(direction) {
        if (direction === -1 && currentHomeSlide > 0) {
            currentHomeSlide -= homeSlidesToShow;
        } else if (direction === 1 && currentHomeSlide + homeSlidesToShow < slides.length) {
            currentHomeSlide += homeSlidesToShow;
        }
        updateSlider(container, currentHomeSlide, homeSlidesToShow);
    }

    function updateSlider(container, currentHomeSlide, homeSlidesToShow) {
        currentHomeSlide = Math.max(0, Math.min(currentHomeSlide, slides.length - homeSlidesToShow));
        const slider = container.querySelector('.home-slider');
        const slideWidth = 100 / homeSlidesToShow;
        slider.style.transform = `translateX(-${currentHomeSlide * slideWidth}%)`;

        const prevButton = container.querySelector('.home-slide-prev');
        const nextButton = container.querySelector('.home-slide-next');
        prevButton.style.display = currentHomeSlide > 0 ? 'block' : 'none';
        nextButton.style.display = (currentHomeSlide + homeSlidesToShow) < slides.length ? 'block' : 'none';
    }

    updateSlider(container, currentHomeSlide, homeSlidesToShow);
}
